export default __webpack_public_path__ + "static/media/location_icon.f303d435.svg";